import React from 'react';
import { shape, string } from 'prop-types';
import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';

import './TableRow.scss';

export default class TableRow extends BaseComponent {
  render() {
    const { style, id, className, children } = this.props;

    const classNames = ClassNames(['TableRow', className]);

    return (
      <tr style={style} id={id} className={classNames}>
        {children}
      </tr>
    );
  }
}

TableRow.propTypes = {
  style: shape({}),
  id: string,
  className: string
};

TableRow.defaultProps = {
  style: {},
  id: undefined,
  className: undefined
};
